export default __webpack_public_path__ + "static/media/venice_water_2.83d36c6a.png";